import {
  createRouter,
  // createWebHistory
  createWebHashHistory,
} from "vue-router";
import { router as brandRouter } from "./modules/brand";
import { router as abilityRouter } from "./modules/ability";
import { router as serveRouter } from "./modules/serve";
import { router as empowermentRouter } from "./modules/empowerment";
export const withHeaderRoutes = [
  {
    name: "home",
    path: "/home",
    meta: {
      title: "关于优越",
      title_en: "HOME",
      showOnNavMenu: true,
      navMenuMode: "custom",
      hideComFooter: false,
      headerNavTheme: "dark",
      iconfont: "icon-31shouye",
      showLogoTitle: true,
    },
    component: () => import("@/views/homePage/index.vue"),
  },
  abilityRouter,
  serveRouter,
  brandRouter,
  {
    path: "/product",
    name: "product",
    meta: {
      title: "产品介绍",
      title_en: "PRODUCT",
      showOnNavMenu: true,
      navMenuMode: "custom",
      iconfont: "icon-pinpai",
      dropDown:true,
      subBar: true,
    },
    redirect: () => {
      return { name: "productList" };
    },
    component: () => import("@/views/product/product.vue"),
    children: [
      {
        path: "productList",
        name: "productList",
        meta: {
          title: "产品展示",
          showOnNavMenu: true,
        },
        component: () =>
          import("@/views/product/views/productList/productList.vue"),
      },
      // {
      //   path: "/productDetails",
      //   name: "productDetails",
      //   meta: {
      //     title: "商品详情",
      //     navMenuMode: "default",
      //     headerNavTheme: "light",
      //   },
      //   component: () =>
      //     import("@/views/product/views/productDetails/productDetails.vue"),
      // },
    ],
  },
  empowermentRouter,
  {
    path: "youyueContact",
    name: "youyueContact",
    meta: {
      title: "联系我们",
      title_en: "CONTACT",
      showOnNavMenu: true,
      navMenuMode: "custom",
      iconfont: "icon-chanpin",
      dropDown: false,
      subBar: true,
    },
    redirect() {
      return { name: "contact" };
    },
    children: [
      {
        path: "contact",
        name: "contact",
        meta: {
          title: "联系我们",
          dropDown: false,
          showOnNavMenu: true,
        },
        component: () => import("@/views/contact/index.vue"),
      },
    ],
  },
];

export const routes = [
  {
    path: "/",
    redirect: "home",
    component: () => import("@/router/headerPage.vue"),
    children: withHeaderRoutes,
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test.vue"),
  },
  {
    path: "/mobilePlayVideo",
    name: "mobilePlayVideo",
    component: () =>
      import(
        "@/views/knowledgeShare/views/mobilePlayVideo/mobilePlayVideo.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 同个页面的跳转，不滚动
    if (from.name === to.name) return;

    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
